import React, { useEffect, useMemo, useState } from 'react'

import ArrowIcon from '../../../assets/icons/simple-arrow.svg'
import Routes from '../../../utils/routes'
import { BlogPostConfig, GhostPost } from '../../../utils/types'
import Link from '../../common/Link/Link'
import IconsLoader from '../IconsLoader/IconsLoader'
import styles from './ContentsTool.module.scss'

type Props = {
  post: GhostPost
  scrollPos: number
  staticMode?: boolean
  hidden?: boolean
  postConfig: BlogPostConfig
}

const STRINGS = {
  back: 'Back',
}

const ContentsTool: React.FC<Props> = ({ post, scrollPos, hidden, staticMode, postConfig }) => {
  const handleInitParagraphs = () => {
    const elements = postConfig.headings
    return elements
      .map((el) => ({
        id: el.id,
        name: el.text || '',
        top: 0,
        height: 0,
        scrollTo: () => undefined,
      }))
      .filter((el) => !!el.id && !!el.name)
  }
  const handleUpdateParagraphs = () => {
    const commentsId = 'blog-post-comments'
    const elements = Array.from(document.querySelectorAll(`h2, #${commentsId}`))
    const isLastElementComments = elements[elements.length - 1]?.id === commentsId
    setParagraphs(
      elements
        .slice(0, elements.length - (isLastElementComments ? 1 : 0))
        .map((el, index) => ({
          id: el.id,
          // @ts-ignore
          name: el.innerText || '',
          // @ts-ignore
          top: el.offsetTop,
          // @ts-ignore
          height: isLastElementComments ? elements[index + 1].offsetTop - el.offsetTop : 0,
          icon: Array.from(el.parentNode?.parentNode?.childNodes || []).find(
            // @ts-ignore
            (t) => typeof t.className === 'string' && t.className?.includes('icon'),
            // @ts-ignore
          )?.className,
          scrollTo: () => el.scrollIntoView(),
          href: `#${el.id}`,
        }))
        .filter((el) => !!el.id && !!el.name),
    )
    setIconsInit(true)
  }

  const [iconsInit, setIconsInit] = useState(false)
  const [paragraphs, setParagraphs] = useState<
    {
      scrollTo: () => void
      href?: string
      icon?: string
      id: string
      name: string
      top: number
      height: number
    }[]
  >(handleInitParagraphs())

  const activeParagraph = useMemo(() => {
    if (!paragraphs?.length || !scrollPos) return null

    return paragraphs.find((p, index) => {
      const currScroll = scrollPos - 120
      const top = p.top
      const bottom = p.top + p.height
      const currScrollEnd = currScroll + window.innerHeight
      const lastAndVisible = index === paragraphs.length - 1 && currScroll < bottom && bottom < currScrollEnd
      return (currScroll < top && top < currScrollEnd) || (bottom > currScrollEnd && top < currScroll) || lastAndVisible
    })
  }, [paragraphs, scrollPos])

  useEffect(() => {
    const interval = setInterval(handleUpdateParagraphs, 1000)
    return () => clearInterval(interval)
  }, [])

  if (hidden || paragraphs.length < 2) return <div />
  return (
    <div className={styles.contentsMenu} data-static={staticMode}>
      {!staticMode && post.type !== 'guide-post' && (
        <Link className={styles.backButton} href={Routes.BLOG}>
          <ArrowIcon />
          {STRINGS.back}
        </Link>
      )}
      {paragraphs?.length ? (
        <div className={styles.paragraphs} data-static={staticMode}>
          <div className={styles.title} data-static={staticMode}>
            Contents
          </div>
          <div>
            {paragraphs.map((p, index) => (
              <Link
                onClick={(e: any) => {
                  e.preventDefault()
                  p.scrollTo()
                }}
                href={p.href || ''}
                key={p.id}
                data-active={activeParagraph?.id === p.id}
                data-static={staticMode}
              >
                {staticMode ? <div className={`${p.icon} ${styles.icon}`}></div> : null}
                <div className={styles.number}>{index + 1}.</div>
                <div>{p.name}</div>
              </Link>
            ))}
          </div>
        </div>
      ) : null}
      {iconsInit && <IconsLoader post={post} />}
    </div>
  )
}

export default ContentsTool
